// components/Common/FileViewerModal.jsx

import { useMemo } from "react";
import PdfViewerModal from "./PdfViewerModal/PdfViewerModal";
import ImageViewer from "./ImageViewer/ImageViewer";

const FileViewerModal = ({
  isOpen = false,
  onClose = () => {},
  fileUrl = "",
  fileName = "Document",
}) => {
  const isPdf = useMemo(() => {
    if (!fileUrl) return false
    return fileUrl.toLowerCase().endsWith(".pdf")
  }, [fileUrl])

  if (!isOpen || !fileUrl) return null

  return isPdf ? (
    <PdfViewerModal
      isOpen={isOpen}
      onClose={onClose}
      pdfUrl={fileUrl}
      fileName={fileName}
    />
  ) : (
    <ImageViewer
      isOpen={isOpen}
      onClose={onClose}
      images={[fileUrl]}
      title={fileName}
    />
  )
}

export default FileViewerModal
